<template>
  <li
    :style="nodeMargin"
    :class="['base-node']"
    role="treeitem"
    :aria-expanded="showChildren ? 'true' : 'false'"
    :aria-selected="isActive ? 'true' : 'false'">
    <button :class="['base-node__button', {'base-node__button--active': isActive}]" :aria-label="ariaLabel" @click.stop="handleNodeClicked">
      <span>{{ node.name }}</span><span v-if="node.hits" class="base-node__hits">{{ `(${node.hits})` }}</span>
    </button>
    <ul v-show="hasChildren && showChildren" class="base-node__container" role="group">
      <oie-base-node
        v-for="child in node.children"
        :key="child.id"
        :node="child"
        :spacing="spacing + 10"
        :active-node="activeNode"
        class="base-node__item"
        @node-active="handleNodeActive"></oie-base-node>
    </ul>
  </li>
</template>

<script>
export default {
  props: {
    node: {
      type: Object,
      required: true
    },
    spacing: {
      type: Number,
      default: 0
    },
    activeNode: {
      type: String,
      required: true
    },
    alwaysShowChildren: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showChildren: false
    }
  },
  computed: {
    isActive() {
      return this.activeNode === this.node.code
    },
    hasChildren() {
      const { children } = this.node
      return children && children.length > 0
    },
    nodeMargin() {
      return {
        'margin-left': `${this.spacing}px`
      }
    },
    ariaLabel() {
      return this.node.hits ? `${this.node.name} ${this.tStatic('hits')} ${this.node.hits}` : this.node.name
    }
  },
  mounted() {
    this.showChildren = this.alwaysShowChildren
    if(this.isActive) {
      this.showChildren = true
      this.$emit('node-active', true)
    }
    this.subscribe('close-all-nodes', () => {
      if(!this.alwaysShowChildren) {
        this.showChildren = false
      }
    })
  },
  updated() {
    if(this.isActive) {
      this.showChildren = true
      this.$emit('node-active', true)
    }
  },
  methods: {
    handleNodeClicked() {
      this.publish('node-clicked', this.node.code)
      if(this.hasChildren) {
        this.showChildren = true
      }
    },
    handleNodeActive() {
      this.showChildren = true
      this.$emit('node-active', true)
    }
  }
}
</script>

<style lang="scss">
.base-node {
  margin: 0;
  white-space: nowrap;
}

.base-node ul[role="group"]{
  @include reset-list;
}

.base-node span:first-child {
  margin-right: measure(eighth);
}

.base-node__button {
  @include body-smaller;
  @include reset-button;
}

.base-node__button span:first-child {
  text-decoration: underline;
}

.base-node__button--active span:first-child{
  font-weight: 600;
  text-decoration: none;
}

.base-node__container {
  margin-top: measure(eighth);
}

.base-node__item {
  position: relative;
  padding: 2px 0 2px measure(quarter);
}

.base-node__item::before {
  content: '';
  position: absolute;
  left: -8px;
  width: 1px;
  height: 100%;
  display: block;
  background: color(gray-4);
}

.base-node__item:last-child::before {
  top: 0;
  height: 10px;
}

.base-node__item::after {
  content: '';
  position: absolute;
  top: 10px;
  left: -8px;
  width: 1rem;
  height: 1px;
  display: block;
  background: color(gray-4);
}

.base-node__hits {
  color: color(gray-2);
}
</style>
